import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

export default class DailyAccountExpenseReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentMonth:moment().month()+1,
            currentYear:moment().year()
        };
        this.handleReportGeneration = this.handleReportGeneration.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
    }
    buildMonthOptions() {
        var arr = [];
        for (let i = 1; i <= 12; i++) {
        arr.push(<option key={i} value={i}>{moment(i, 'MM').format('MMM')}</option>)
        }
        return arr; 
    }
    buildYearOptions() {
        var arr = [];
        for (let i = 1; i <= 5; i++) {
            let nyear = moment().add(i, 'years').format('YYYY');
            arr.push(<option key={i+nyear} value={nyear}>{nyear}</option>)
        }
        return arr; 
    }
    buildPrevYearOptions() {
        var arr = [];
        for (let i = 5; i >= 1; i--) {
            let pyear = moment().subtract(i, 'years').format('YYYY');
            arr.push(<option key={i+pyear} value={pyear}>{pyear}</option>)
        }
        return arr; 
    }
    handleReportGeneration(e){
        let url = "/api/v1/portal/finance/daily-account-expense-report/"+this.state.currentMonth+"/"+this.state.currentYear;
        return fetch(url,{
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json',
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => response.blob())
        .then(blob => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = "Account Expense Report "+moment(this.state.currentMonth, 'MM').format('MMM')+' '+this.state.currentYear+".xlsx";
            document.body.appendChild(a); 
            a.click();    
            a.remove(); 
        }).catch(err=>{
           alert('sorry something went wrong.') ;
        });
    }
    handleMonthChange(e){
        this.setState({currentMonth:e.target.value});
    }
    handleYearChange(e){
        this.setState({currentYear:e.target.value});
    }
    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Daily Account Expense Report</h2>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>Select Month:</label>
                            <select className="form-control" id="months" defaultValue={this.state.currentMonth} onChange={(e)=>this.handleMonthChange(e)}>
                                {this.buildMonthOptions()}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>Select Year:</label>
                            <select className="form-control" id="years" defaultValue={this.state.currentYear} onChange={(e)=>this.handleYearChange(e)}>
                                {this.buildPrevYearOptions()}
                                <option key={moment().year()} value={moment().year()}>{moment().year()}</option>
                                {this.buildYearOptions()}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-primary generate-daily-account-expense-report" onClick={(e)=>this.handleReportGeneration(e)}><b>Generate Report</b></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById(
    'react-component-g4-logistics-portal-daily-account-expense-report')) {
    ReactDOM.render(
    <DailyAccountExpenseReport
        message_if_none = 'Nothing to report on.'
        />,
    document.getElementById(
            'react-component-g4-logistics-portal-daily-account-expense-report'
            )
    );
}
